export default (cardNumber, text = '', prefix = '*') =>
  `${text} ${prefix}${cardNumber.substring(cardNumber.length - 4)}`;
